import React, { Component } from 'react';
import { Link  } from 'react-router-dom';
import { connect } from 'react-redux';
import '../../../css/styleMenu.css';

class menu extends Component {

constructor(props){

    super(props);

    this.state = { lista:[]}
}
  
    
    renderMenu(){

        switch (this.props.lado) {
            
            case 'esquerdo':

              return [
                               {
                                'nome_menu':"Painel de controle",
                                'link_menu':this.props.menu.home,
                                'icone': 'gamefica-icon gamefica-dashboard'
                               },
                               {
                                'nome_menu':"Talentos",
                               // 'link_menu':{},
                                'link_menu':this.props.menu.talentos.home,
                                'icone': 'gamefica-icon gamefica-badge'
                               },
                               {
                                'nome_menu' : "Desafios",
                                //'link_menu':this.props.menu.desafios.home,
                                'link_menu':{},
                                'icone': 'gamefica-icon gamefica-stats'
                               },
                               {
                                'nome_menu' : "Batalhas",
                                //'link_menu':this.props.menu.batalha.aluno.home,
                                'link_menu':{},
                                'icone': 'gamefica-icon gamefica-spaceship'
                               }
                               
                              ]

                
            break;

            case 'direito':

          return [
                {
                 'nome_menu':"Comunicação",
                 'link_menu':this.props.menu.comunicacao.tripulacao,
                 'icone': 'gamefica-icon gamefica-chatroom'
                },
                {
                'nome_menu':"Missão",
                'link_menu' : this.props.menu.missao.home,
                'icone': 'gamefica-icon gamefica-target'
               },
               {
                'nome_menu' : "Treinamentos cérebrais",
               // 'link_menu' : this.props.menu.missao.home,
               'link_menu':{},
                'icone': 'gamefica-icon gamefica-brain'
               },
               {
                'nome_menu' : "Treinamentos cerebrais",
                'link_menu':{},
                'icone': 'gamefica-icon gamefica-warning'
               },

            ]

                
            break;
        
          
        }

    }


    render(){

        const lista   = this.renderMenu();
        const retorno = lista.map((elem,i)=>{
            const dis = {'opacity':'0.5','cursor':'default'}
            const disabledMenu = (elem.link_menu.length === undefined ?dis:{'cursor':'pointer'});

            return  <li key={i}><Link to={elem.link_menu} style={disabledMenu}><i className={elem.icone}></i></Link></li>;
        });    
        return (<ul>{retorno}</ul>);
    }
}

function mapStateToProps(state){

    return {menu : state.configReducer.menu };
}

export default connect(mapStateToProps)(menu);



// WEBPACK FOOTER //
// ./src/components/aluno/menu/menu.js